import React from "react";
import { GPDP_LOGO } from "@/lib/constants";

/**
 * KopSurat — official letterhead for GPDP Klasis Mimika outgoing letters.
 * Renders on-screen and prints cleanly on A4.
 */
export default function KopSurat({ profile }) {
  const p = profile || {};
  return (
    <div className="kop-surat" data-testid="kop-surat">
      <div className="kop-header">
        <div className="kop-logo-wrap">
          <img src={GPDP_LOGO} alt="Logo GPDP" className="kop-logo" />
        </div>
        <div className="kop-body">
          <div className="kop-title-main">GEREJA PENTAKOSTA DI PAPUA</div>
          <div className="kop-title-sub">
            BADAN PEKERJA KLASIS MIMIKA
            <span className="kop-title-tail"> • Periode {p.periode_start?.slice(0,4) || "2026"}–{p.periode_end?.slice(0,4) || "2031"}</span>
          </div>
          <div className="kop-address">
            {p.address || "Jl. Cendrawasih Timika Indah, Kabupaten Mimika"}
            {p.address2 && <>, {p.address2}</>}
          </div>
          <div className="kop-contact">
            {p.phone && <span>Telp: {p.phone}</span>}
            {p.email && <span>Email: {p.email}</span>}
            {p.website && <span>Web: {p.website}</span>}
          </div>
        </div>
      </div>
      <div className="kop-rule" />
      <div className="kop-rule-thin" />
    </div>
  );
}
